// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_mr-5";
export var filledCircle = "_mr-4";
export var historyEntry = "_mr-3";
export var messageSideLeft = "_mr-1";
export var messageSideRight = "_mr-2";
export var orderTrackingCarouselWrapper = "_mr-6";
export var orderTrackingInfoContainer = "_mr-0";